module.exports = __webpack_public_path__ + "static/img/program_06.9ef0ade.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_06.jpg
// module id = KTRt
// module chunks = 0